var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root profile-settings"},[_c('h1',{staticClass:"page-title lx-page-title"},[_vm._v("Profile")]),(_vm.isLoaded)?[(_vm.isFreelancer)?_c('FreelancerProfile'):_c('CustomerProfile')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }